import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DATE_ALIAS } from 'common/constants/general';
import { setQueryString } from 'utilities';
import { SetDateQueryParamOptions, UseDateQueryParamReturn } from './useDateQueryParam.types';

const useDateQueryParam = (): UseDateQueryParamReturn => {
  const navigate = useNavigate();
  const location = useLocation();

  const setDateQueryParam = useCallback(
    (params: SetDateQueryParamOptions) => {
      const { date } = params;

      setQueryString({
        navigate,
        paramName: DATE_ALIAS,
        paramValue: date,
        pathname: location.pathname,
        searchParams: location.search,
      });
    },
    [navigate, location.pathname, location.search]
  );

  return { setDateQueryParam };
};

export default useDateQueryParam;
